import React from 'react';

const News = () => {
  return (
    
      <span> <a href="https://cryptonews.com/" target="_blank" rel="noreferrer">News</a></span>
  
  );
};

export default News;
